__turbopack_context__.v({
  "closeButton": "Modal-module__vaK8Va__closeButton",
  "fadeIn": "Modal-module__vaK8Va__fadeIn",
  "modalBody": "Modal-module__vaK8Va__modalBody",
  "modalContent": "Modal-module__vaK8Va__modalContent",
  "modalHeader": "Modal-module__vaK8Va__modalHeader",
  "modalOverlay": "Modal-module__vaK8Va__modalOverlay",
  "slideUp": "Modal-module__vaK8Va__slideUp",
});
